import React from 'react';
import { Grid, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';


interface ITimeEntryProps {
    time?: any;
    onTimeChange: (updatedTime: any) => void;
    onIsActiveChange?: (isActive: boolean) => void;
}

const ITimeEntry: React.FC<ITimeEntryProps> = ({
    time,
    onTimeChange,
    onIsActiveChange
}) => {
    const [timeEntryValue, setTimeEntryValue] = React.useState<string>('0h 0m');
    const [finalizeTimeEntryValue, setFinalizeTimeEntryValue] = React.useState<string>('0h 0m');
    const [isTimeEntryError, setIsTimeEntryError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState('');

    const handleTimeEntryInput = (event) => {
        let value = event.target.value;
        setTimeEntryValue(value);
        setIsTimeEntryError(false);
    }

    const convertToHoursAndMinutes = (totalMinutes: number) => {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours > 0 ? hours + 'h ' : '0h '}${minutes > 0 ? minutes + 'm' : '0m'}`.trim();
    };

    const submitTimeEntryValue = () => {
        const regex = /^(\d+h\s\d+m|\d+m|\d+h|\d+)$/;
        let value = timeEntryValue.trim();

        if (!regex.test(value)) {
            setIsTimeEntryError(true);
            setErrorMessage('Value must be in the format 4h 35m.');
            return;
        }

        let totalMinutes = 0;
        if (/^\d+$/.test(value)) {
            totalMinutes = parseInt(value, 10);
            value = convertToHoursAndMinutes(totalMinutes);
        } else {
            const hoursMatch = value.match(/(\d+)h/);
            const minutesMatch = value.match(/(\d+)m/);

            if (hoursMatch) {
                totalMinutes += parseInt(hoursMatch[1], 10) * 60;
            }
            if (minutesMatch) {
                totalMinutes += parseInt(minutesMatch[1], 10);
            }

            value = convertToHoursAndMinutes(totalMinutes);
        }

        // // Validate total minutes
        // if (totalMinutes > 1440) {
        //     setIsTimeEntryError(true);
        //     setErrorMessage('Maximum allowed time is 1440 minutes (24 hours).');
        //     return;
        // } else {
        //     setIsTimeEntryError(false);
        //     setErrorMessage('');
        // }
        onTimeChange(value);

        //set finalize time entry value
        if (!isTimeEntryError) {
            setFinalizeTimeEntryValue(value);
            onIsActiveChange(false);
        }
    }

    const cancelTimeEntryValue = () => {
        setTimeEntryValue(finalizeTimeEntryValue);
        setIsTimeEntryError(false);
        onIsActiveChange(false);
    }


    //set initial value
    React.useEffect(() => {
        const timeValue = time ? time : '0h 0m';
        setTimeEntryValue(timeValue);
        setFinalizeTimeEntryValue(timeValue);
    }, []);

    return (
        <Grid>
            <Grid className="custom-time-entry-main-content" sx={{ position: 'relative' }}>

                <TextField
                    label="Planned Hours"
                    fullWidth
                    onChange={handleTimeEntryInput}
                    value={timeEntryValue}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {isTimeEntryError && (
                                    <Tooltip
                                        title={
                                            <Typography
                                                style={{
                                                    fontSize: '11px',
                                                    wordBreak: 'break-word'
                                                }}
                                            >
                                                {errorMessage}
                                            </Typography>
                                        }
                                        arrow
                                    >
                                        <WarningIcon
                                            sx={{
                                                color: '#e67e22',
                                                fontSize: '1.2rem',
                                                marginRight: '-10px'
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </InputAdornment>
                        ),
                        style: {
                            height: '2rem',
                            fontSize: '12px',
                            marginTop: 4,
                        }
                    }}
                    error={isTimeEntryError}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            submitTimeEntryValue();
                        }
                    }}
                    onFocus={(event) => {
                        event.target.select();
                    }}
                />
                <Grid
                    sx={{

                        display: 'flex',
                        gap: '10px',
                        zIndex: 1000,
                        marginLeft: '10px',
                        alignItems: 'center'
                    }}
                >
                    <CheckIcon
                       sx={{
                        fontSize: '1.3rem',
                        cursor: 'pointer',
                        borderRadius: '4px',
                        padding: '2px',
                        color: 'green',
                      }}
                        onClick={submitTimeEntryValue}
                    />
                    <CloseIcon
                          sx={{
                            fontSize: '1.3rem',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            padding: '2px',
                            color: 'red',
                          }}
                        onClick={cancelTimeEntryValue}
                    />
                </Grid>
            </Grid>

        </Grid>
    );
};

export default ITimeEntry;
